import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useSearchParams } from "react-router-dom";

/**
 * Switches among active documents, frames, and recoverable document Trash.
 * The mode lives in the `view` search param so it survives reloads and can be
 * linked to; the param is dropped entirely for the default documents mode.
 */
export const DocumentsPageViewToggle = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentView = searchParams.get("view");

  const handleViewChange = (nextView: string | null) => {
    if (!nextView) {
      return;
    }

    setSearchParams((currentSearchParams) => {
      const nextSearchParams = new URLSearchParams(currentSearchParams);

      if (nextView === "frames" || nextView === "trash") {
        nextSearchParams.set("view", nextView);
      } else {
        nextSearchParams.delete("view");
      }

      return nextSearchParams;
    });
  };

  return (
    <ToggleButtonGroup
      aria-label="Documents page view"
      exclusive
      onChange={(_event, nextView) => handleViewChange(nextView)}
      size="small"
      value={
        currentView === "frames" || currentView === "trash"
          ? currentView
          : "documents"
      }
      sx={{
        "& .MuiToggleButton-root": {
          fontSize: 12,
          lineHeight: 1,
          px: 1.25,
          py: 0.5,
          textTransform: "none",
        },
      }}
    >
      <ToggleButton value="documents">Documents</ToggleButton>
      <ToggleButton value="frames">Frames</ToggleButton>
      <ToggleButton value="trash">Trash</ToggleButton>
    </ToggleButtonGroup>
  );
};
